import { render, staticRenderFns } from "./TransferDesignModal.vue?vue&type=template&id=b92a17fe"
import script from "./TransferDesignModal.vue?vue&type=script&lang=js"
export * from "./TransferDesignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports